export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const toUpperCase = (string: string) => {
  return string.replace(/\b\w/g, (l) => l.toUpperCase());
};

export const getInitials = (firstName: string, lastName: string): string => {
  let initials = "";
  initials = initials + firstName.charAt(0);
  initials = initials + lastName.charAt(0);
  initials = initials.toUpperCase();
  return initials;
};

export const parseSearchParams = (queryString: string) => {
  let query: any = {};
  let pairs = (queryString[0] === "?"
    ? queryString.substr(1)
    : queryString
  ).split("&");
  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
};

export function removeSpecialChars(string: string) {
  if (!string) return "";
  return string.replace(/[-&/\\#,()$~%.'":*?<>{}]/g, "");
}

export function removeSpecialCharsForNum(string: string) {
  if (!string) return "";
  return string.replace(/[&/\\#,()$~%'":*?<>{}]/g, "");
}

export function removeLetters(string: string) {
  if (!string) return "";
  return string.replace("[^a-zA-Z]", "");
}

export function sanitizeName(name: string) {
  if (!name) return "";
  let sanitizedName = name.trim();
  sanitizedName =
    sanitizedName.charAt(0).toUpperCase() + sanitizedName.slice(1);
  return sanitizedName;
}

export function sanitizePostalCode(postalCode: string) {
  if (!postalCode) return "";
  let sanitizedPostalCode = postalCode.trim();
  sanitizedPostalCode = sanitizedPostalCode.toUpperCase();
  sanitizedPostalCode = sanitizedPostalCode.replace(/\s+/g, "");
  return sanitizedPostalCode;
}

export function sanitizePhoneNumber(phoneNumber: string) {
  if (!phoneNumber) return "+1";
  let sanitizedPhoneNumber = trimFull(phoneNumber);
  sanitizedPhoneNumber = sanitizedPhoneNumber.replace(
    /[&/\\#,()$~%.'":*?<>{}-]/g,
    ""
  );
  if (sanitizedPhoneNumber.substring(0, 2) !== "+1") {
    sanitizedPhoneNumber = `+1${sanitizedPhoneNumber}`;
  }
  return sanitizedPhoneNumber;
}

export function insertDecimal(number: number) {
  if (!number) return number;
  return Number(number.toFixed(2));
}

export function trimFull(string: string) {
  if (!string) return "";
  let sanitizedString = string.trim();
  sanitizedString = sanitizedString.replace(/\s+/g, "");
  return sanitizedString;
}

export function sanitizeNumber(string: string) {
  if (!string) return 0;
  let number: any = trimFull(string);
  number = number.replace(/[&/\\#,()$~%.'":*?<>{}]/g, "");
  number = number.replace(/^[0]+/g, "");
  number = parseFloat(number);
  return number;
}

export function formatPhoneNumber(phoneNumberString: string) {
  if (phoneNumberString === "") return "+1";
  if (!phoneNumberString) return "";
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return "";
}

export function returnValidString(string?: string) {
  return string ? string : "";
}

export function returnStringOrNA(string: string | undefined | null) {
  return string ? string : "N/A";
}

export function returnValidDate(date: Date) {
  return date.getTime() ? date : new Date();
}

export function returnValidNumber(number: number | null) {
  return number === null || number === undefined ? 0 : number;
}

export function formatLoanNumber(string: string): string {
  if (!string) return "";
  if (string.length > 1 && string.charAt(1) !== "-") {
    return string.slice(0, 1) + "-" + string.slice(1, string.length);
  } else {
    return string;
  }
}

export function camelize(string: string) {
  return string.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

export function pascalize(string: string) {
  return string.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return match.toUpperCase();
  });
}

export const formatNumberWithCommas = (string: string) => {
  if (!string) return "";
  const n = string;
  const p = n.indexOf(".");
  return n.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) =>
    p < 0 || i < p ? `${m},` : m
  );
};

const re = /^[0-9.\b]+$/;
export const isNumber = (string: string) => {
  return re.test(string);
};

export const getLetter = (index: number): string => {
  const letters = 'abcdefg'.split('');
  return letters[index];
}
// hijklmnopqrstuvwxyz

export const convertStringToArray = (object) => {
  return (typeof object === 'string') ? Array(object) : object
}